<template>
<div class="odr-section-collapsible">
    <slot></slot>
</div>
</template>

<script>
import '@/scss/blocks/section-collapsible.scss';
export default {
    props: {
        collapsible: {
            type: String,
            default: 'false',
        },
        name: {
            type: String,
            default: 'false',
        },
    },
    data () {
        return {
            isCollapsible: this.collapsible === 'true',
            qaName: this.name || '',
        };
    },
};
</script>
